import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Events from 'modules/events/Events';
import EventDetails from 'modules/events/EventDetails';
import Landing from 'modules/landing';
import MainLayout from 'components/layouts/MainLayout';
import Programs from 'modules/programs';
import Addons from 'modules/programs/AddOns';
import CaseStudy from 'modules/case-study';
import PressRelease from 'modules/press-release';
import ContactUs from 'modules/contact/contactUs';
// programs
import CSBC from 'modules/programs/Csbc';
import Liheap from 'modules/programs/Liheap';
import HeadStart from 'modules/programs/HeadStart';
import Transportation from 'modules/programs/Transportation';
import VictimSupport from 'modules/programs/VictimSupport';
import Nutrition from 'modules/programs/Nutrition';
import Weatherization from 'modules/programs/Weatherization';
import CaseManagement from 'modules/programs/CaseManagement';
import YouthPrograms from 'modules/programs/YouthPrograms';
import HousingAssistance from 'modules/programs/HousingAssistance';

import ClientKiosk from 'modules/addons/ClientKiosk';
import StateKiosk from 'modules/addons/StateKiosk';
import IDScanner from 'modules/addons/IDScanner';
import CustomSurvey from 'modules/addons/CustomSurvey';
import ElectronicSignature from 'modules/addons/ElectronicSignature';
import BarcodeScanner from 'modules/addons/BarcodeScanner';
import CampaignManager from 'modules/addons/CampaignManager';
import AutoDialer from 'modules/addons/AutoDialer';
import MailingWizard from 'modules/addons/MailingWizard';

import PressReleaseDetailsOne from 'modules/press-release/PressReleaseDetailsOne';
import PressReleaseDetailsTwo from 'modules/press-release/PressReleaseDetailsTwo';
import PressReleaseDetailsThree from 'modules/press-release/PressReleaseDetailsThree';
import RouteScrollTop from 'components/RouteScrollTop';

export default function AppRouter() {
  return (
    <BrowserRouter>
      <RouteScrollTop />
      <MainLayout>
        <Switch>
          <Route exact path="/">
            <Landing />
          </Route>
          <Route exact path="/events">
            <Events />
          </Route>
          <Route exact path="/event/:id">
            <EventDetails />
          </Route>
          {/* programms starts */}
          <Route exact path="/programs">
            <Programs />
          </Route>
          <Route exact path="/csbg">
            <CSBC />
          </Route>
          <Route exact path="/liheap">
            <Liheap />
          </Route>
          <Route exact path="/head-start">
            <HeadStart />
          </Route>
          <Route exact path="/transportation">
            <Transportation />
          </Route>
          <Route exact path="/victim-support-services">
            <VictimSupport />
          </Route>
          <Route exact path="/nutrition">
            <Nutrition />
          </Route>
          <Route exact path="/Weatherization">
            <Weatherization />
          </Route>
          <Route exact path="/case-management">
            <CaseManagement />
          </Route>
          <Route exact path="/youth-programs">
            <YouthPrograms />
          </Route>
          <Route exact path="/housing-assistance">
            <HousingAssistance />
          </Route>
          <Route exact path="/campaign-manager">
            <CampaignManager />
          </Route>
          {/* programms ends */}
          {/* addons pages starts */}
          <Route exact path="/add-ons">
            <Addons />
          </Route>
          <Route exact path="/client-kiosk">
            <ClientKiosk />
          </Route>
          <Route exact path="/state-kiosk">
            <StateKiosk />
          </Route>
          <Route exact path="/id-card-scanner">
            <IDScanner />
          </Route>
          <Route exact path="/custom-survey">
            <CustomSurvey />
          </Route>
          <Route exact path="/electronic-signature">
            <ElectronicSignature />
          </Route>
          <Route exact path="/barcode-scanner">
            <BarcodeScanner />
          </Route>
          <Route exact path="/auto-dialer">
            <AutoDialer />
          </Route>
          <Route exact path="/mailing-wizard">
            <MailingWizard />
          </Route>
          {/* addons pages ends */}
          <Route exact path="/case-study">
            <CaseStudy />
          </Route>
          <Route exact path="/press-release">
            <PressRelease />
          </Route>
          {/* press releases details */}
          <Route
            exact
            path="/press-release/the-community-action-partnership-of-utah-selects-cap60-for-data-management-need"
            component={PressReleaseDetailsOne}
          />
          <Route
            exact
            path="/press-release/dallas-selects-cap60-to-provide-data-management-services-for-their-new-csbg-entity"
            component={PressReleaseDetailsTwo}
          />
          <Route
            exact
            path="/press-release/north-dakota-selects-cap60-for-data-management-needs"
            component={PressReleaseDetailsThree}
          />
          <Route
            exact
            path="/press-release/north-dakota-selects-cap60-for-data-management-needs"
            component={PressReleaseDetailsThree}
          />
          {/* press releases details */}
          <Route exact path="/contact-us">
            <ContactUs />
          </Route>
        </Switch>
      </MainLayout>
    </BrowserRouter>
  );
}
